import { createStyles } from '@mui/styles';
import { APTheme } from '../../../core/TenantProvider/tenants';

export default (theme: APTheme) => createStyles({
    filtersItem: {
        '& button': {
            backgroundColor: '#fff',
            cursor: 'pointer',
            color: '#4a4a4a',
            display: 'block',
            lineHeight: '1',
            padding: '.875em 4rem .875em 1em',
            textDecoration: 'none',
            textAlign: 'left',
            fontWeight: 400,
            border: '1px solid #ccc',
            borderRadius: 4,
            position: 'relative',
            fontSize: '95%',
            minWidth: 150,
            whiteSpace: 'nowrap',
            [theme.breakpoints.down('md')]: {
                width: '100%',
            },
            '& > span': {
                color: '#2D91E9'
            },
            '&:focus': {
                outline: 'none'
            },
            '&.is-active': {
                borderColor: 'transparent',
                boxShadow: '0 0 15px rgba(0,0,0,0.15)'
            },
            '&.is-active > svg': {
                transform: 'rotate(180deg)'
            },
        },
        '& svg': {
            position: 'absolute',
            top: 0,
            bottom: 0,
            right: '15px',
            margin: 'auto',
            fontSize: '95%',
            width: '1em',
            height: '1em'
        }
    },
    filterSubItems: {
        boxSizing: 'border-box',
        opacity: 0,
        visibility: 'hidden',
        top: '100%',
        left: '0',
        width: '130%',
        maxWidth: 250,
        position: 'absolute',
        background: '#fff',
        zIndex: 99,
        boxShadow: '0 7px 15px rgba(0,0,0,0.15)',
        padding: '1rem',
        borderRadius: '0 0 4px 4px',
        transform: 'translateY(25px)',
        transitionProperty: 'all',
        transitionDuration: '.20s',
        transitionTimingFunction: 'cubic-bezier(0.31, 0.8, 0.51, 0.96)',
        [theme.breakpoints.down('md')]: {
            width: '100%',
            maxWidth: 'none',
        },
        '&.is-active': {
            opacity: 1,
            visibility: 'visible',
            transform: 'translateY(0)',
        },

        '& ul, & ul li': {
            listStyle: 'none',
            display: 'block',
            margin: 0,
            padding: 0,
        },
        '& ul li': {
            display: 'block',
            marginBottom: 1,
            '& label': {
                fontSize: '95%',
                position: 'relative',
                cursor: 'pointer',
                lineHeight: '1',
                borderRadius: '3px',
                transitionProperty: 'all',
                transitionDuration: '.15s',
                transitionTimingFunction: 'ease-in-out',
                display: 'block',
                padding: '.875rem 2.75rem .875rem 1rem',
                '& svg': {
                    opacity: 0,
                    top: '.875rem',
                    bottom: 'auto',
                    right: '0.6rem',
                    color: '#fff',
                    fill: 'currentColor',
                    fontSize: '115%',
                    transform: 'scale(0,0)',
                    transitionProperty: 'all',
                    transitionDuration: '.20s',
                    transitionTimingFunction: 'cubic-bezier(0.31, 0.8, 0.51, 0.96)',
                },
                '&:hover': {
                    backgroundColor: '#F5F5F5'
                },
                '&.is-active': {
                    color: '#fff',
                    backgroundColor: '#2D91E9',
                    '& svg': {
                        opacity: 1,
                        visibility: 'visible',
                        transform: 'scale(1,1)',
                    },
                },
            },
            '& input': {
                display: 'none',
            }


        }
    }
});
